var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPipelinejoin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 0V1.17647L2.17392 1.37255L3.25236 1.17647L3.44843 0.723L3.25236 0L0.899414 0Z",
    fill: "#FFDF40"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60489 0H3.25195V1.17647L4.42842 1.37255L5.60489 1.17647V0Z",
    fill: "#FFBE40"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 1.17627V5.88215L2.07588 6.07823L3.25236 5.88215L3.44843 3.52921L3.25236 1.17627H0.899414Z",
    fill: "#41AAC1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.60489 1.17627H3.25195V5.88215L4.42842 6.07823L5.60489 5.88215V1.17627Z",
    fill: "#246A7A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.899414 5.88281V7.05928H3.25236L3.44843 6.32399L3.25236 5.88281H0.899414Z",
    fill: "#FFDF40"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25195 5.88281H5.60489V7.05928H3.25195V5.88281Z",
    fill: "#FFBE40"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 9.99999V8.82352L9.62508 8.62744L8.54666 8.82352L8.35059 9.27699L8.54666 9.99999H10.8996Z",
    fill: "#ECE6F2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19434 9.99999H8.54728V8.82352L7.37081 8.62744L6.19434 8.82352V9.99999Z",
    fill: "#FFF5F5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 8.82384V4.11795L9.72313 3.92188L8.54666 4.11795L8.35059 6.4709L8.54666 8.82384H10.8996Z",
    fill: "#246A7A"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19434 8.82384H8.54728V4.11795L7.37081 3.92188L6.19434 4.11795V8.82384Z",
    fill: "#41AAC1"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8996 4.11739V2.94092H8.54666L8.35059 3.67621L8.54666 4.11739H10.8996Z",
    fill: "#ECE6F2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19434 2.94092H8.54728V4.11739H6.19434V2.94092Z",
    fill: "#FFF5F5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M9.59215 1.63686L9.26588 1.14745L8.84078 1.43084V0H8.54666L8.35059 0.901961L8.54666 2.33386L9.59215 1.63686Z",
    fill: "#00BF9F"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.19434 0.588235H8.25316V1.43084L7.82806 1.14745L7.50179 1.63686L8.54728 2.33386V0H6.19434V0.588235Z",
    fill: "#2DE6A8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPipelinejoin);
export default __webpack_public_path__ + "static/media/pipelinejoin.252b32dea5d302e6b731bf1b5779b8e1.svg";
export { ForwardRef as ReactComponent };